import React from 'react';
import parseQueryString from '../../utilities/parseQueryString';
import { clientID } from './spotifyApi';

interface Props {

}

/**
 * After user completes authentication with spotify he is redirected to this component.
 * 
 * This component (and page), living in a child window of the main app, 
 * then uses HTML5 postMessage to allow the main app to complete authorization.
 * 
 */
export default function SpotifyRedirect({

}: Props) {

  var hashObj = parseQueryString(window.location.hash);
  hashObj[clientID] = true;

  const parent = window.opener || window.parent;

  if (parent) {
    parent.postMessage(hashObj, window.location.origin);
  
    window.close();
  } else {
    console.debug('window.opener / window.parent undefined')
  }

  return (
    <></>
  );
};
